module.exports = __webpack_public_path__ + "img/1-13.6688d1bd.png";